import { lazy } from 'react';

export const GroupPage = lazy(() => import('./controller.js'));
